import MSelectUiLocale from './MSelectUILocale.vue';

export { MSelectUiLocale };
export default MSelectUiLocale;
